module.exports = __webpack_public_path__ + "img/1474499820.4d12613c.jpg";